import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { INITINAL_STATE } from "./constant";
import { GetUserProfile } from "@/dto/auth/response/auth-response";
import { AuthState } from "./types";

const authSlice = createSlice({
  name: "auth",
  initialState: INITINAL_STATE,
  reducers: {
    setCredentials: (
      state: AuthState,
      action: PayloadAction<{
        user: GetUserProfile;

        sessionId: string;
      }>
    ) => {
      state.user = action.payload.user;
      state.isAuthenticated = true;
      state.isForbidden = false;
      localStorage.setItem("sessionId", action.payload.sessionId);
    },

    setUser: (
      state: AuthState,
      action: PayloadAction<{
        user: GetUserProfile;
      }>
    ) => {
      state.user = action.payload.user;
    },
    clearAuth: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.isForbidden = false;
      localStorage.removeItem("sessionId");
      localStorage.removeItem("userRole");
      localStorage.removeItem("orgType");
    },
    setForbidden: (state, action: PayloadAction<boolean>) => {
      state.isForbidden = action.payload;
      if (action.payload) {
        state.isAuthenticated = false;
        state.user = null;
      }
    },
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
  },
});

export const {
  setUser,
  setCredentials,
  clearAuth,
  setForbidden,
  setIsAuthenticated,
} = authSlice.actions;

export default authSlice.reducer;
